import { z } from 'zod';
import { leadTrackingSchema } from './tracking-schema';
import { FIELD_MAX } from './field-limits';

/** The four answers the BEST Moves eBook gate offers, in order. */
export const EVENT_TIMING_OPTIONS = [
  'Within 30 days',
  '1 to 3 months',
  '3+ months',
  'Just researching for now',
] as const;

export type EventTiming = (typeof EVENT_TIMING_OPTIONS)[number];

/** eBook download form: identity only — the gate is deliberately light. */
export const ebookSubmissionSchema = z.object({
  firstName: z.string().trim().min(1, 'First name is required').max(FIELD_MAX.name),
  lastName: z.string().trim().min(1, 'Last name is required').max(FIELD_MAX.name),
  email: z.string().trim().email('Enter a valid email address').max(FIELD_MAX.email),
  company: z.string().trim().min(1, 'Company name is required').max(FIELD_MAX.company),
  /** Which eBook was requested (slug). */
  ebook: z.string().trim().min(1).max(100),
  /**
   * When their next team event is. Optional, asked only on BEST Moves pages.
   * It is the whole reason sales can open differently: "within 30 days" is a
   * hole in an agenda we can fill this week, anything further out is a
   * conversation about shaping one.
   */
  eventTiming: z.enum(EVENT_TIMING_OPTIONS).optional(),
  tracking: leadTrackingSchema.optional(),
});

export type EbookSubmission = z.infer<typeof ebookSubmissionSchema>;
